import { Box, Button, CircularProgress, Stack, Typography } from "@mui/material";
import { FieldControl } from "../../../shared/components";
import { useMemo, useState } from "react";
import { projectDetailsApi } from "../api/projectDetails";
import { useGetUsers } from "../../../shared/hooks/useUsers";

export const StakeHolder = ({ onSuccess, onClose, projectId, existingStakeHolders }: { onSuccess: () => void; onClose: () => void; projectId: string | undefined; existingStakeHolders: number[] }) => {

    const [submitting, setSubmitting] = useState(false);
    const [stakeholderErrors, setStakeholderErrors] = useState<{ [key: string]: string }>({});

    const { data: usersData, isLoading } = useGetUsers();

    const userOptions = useMemo(() => {
        if (!usersData?.data) return [];
        return usersData.data.filter((u) => u.is_active === "1" && u.is_stake_holders).map((u) => ({
            value: u.user_id,
            label: u.full_name,
            email: u.email,
            role: u.role
        }));
    }, [usersData]);

    const [stakeHolder, setStakeHolder] = useState<{
        user_id: string | null;
    }>({
        user_id: null
    });

    const handleStakeHolderChange = (key: string, value: any) => {
        setStakeHolder((prevAsset: any) => ({
            ...prevAsset,
            [key]: value
        }));
    };

    const handleSubmit = async () => {
        const errors: { [key: string]: string } = {};
        if (!stakeHolder.user_id) {
            errors.user_id = "User is required.";
        }
        setStakeholderErrors(errors);
        setSubmitting(true);
        if (Object.keys(errors).length === 0) {
            const stakeHolderData = {
                "user_id": Number(stakeHolder.user_id)
            };
            const response = await projectDetailsApi.createStakeHolder({ projectId, stakeHolderData });
            if (response.status) {
                onSuccess();
            }
        }
    };

    const Loader = () => {
        return (
            <Box
                height="100%"
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                width="100%"
                gap={2}
            >
                <CircularProgress />
            </Box>
        )
    }

    if (isLoading) {
        return (
            <Loader />
        )
    };

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>

            <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, gap: 2, p: 2 }}>

                <FieldControl
                    keyName={"user_id"}
                    label={"User"}
                    variant={"select"}
                    value={stakeHolder.user_id}
                    options={userOptions.filter((s: { value: number; label: string; }) => !existingStakeHolders.includes(s.value))}
                    onChange={(_key: string, value: any) => handleStakeHolderChange("user_id", value)}
                    error={!!(stakeholderErrors?.user_id)}
                    helperText={stakeholderErrors?.user_id}
                />

                {
                    stakeHolder.user_id && (
                        <Box sx={{ display: 'flex', flexDirection: 'column', p: 2, bgcolor: 'action.hover', borderRadius: 1 }}>
                            <Typography variant="body2">Email : {userOptions.find((a: { value: number; label: string; }) => { return a.value === Number(stakeHolder.user_id) })?.email}</Typography>
                            <Typography variant="body2">Role : {userOptions.find((a: { value: number; label: string; }) => { return a.value === Number(stakeHolder.user_id) })?.role}</Typography>
                        </Box>
                    )
                }

            </Box>

            <Stack direction="row" spacing={2} justifyContent="flex-end" flexShrink={0} bgcolor={'action.hover'} p={2}>
                <Button variant="outlined" onClick={onClose} disabled={submitting}>Close</Button>
                <Button variant="contained" color="primary" onClick={handleSubmit} disabled={submitting}>Save</Button>
            </Stack>

        </Box>
    )
};